export default "__VITE_ASSET__D08DuzlP__"